
import { defineComponent, computed, PropType } from 'vue'
import { useStore } from 'vuex'

import type { VideoInfo } from '@/api/type'
import { MUTATIONS_KEYS } from '@/store/mutations'

export default defineComponent({
  name: 'VideoFavorite',
  props: {
    video: {
      type: Object as PropType<VideoInfo['data'][0]>,
      required: true
    }
  },
  setup (props) {
    const store = useStore()
    const id = computed(() => props.video ? props.video.id : '')


    const isFavorite = computed(() => {
      const { favorite } = store.state
      return favorite.some(video => video.id === id.value)
    })

    const onFavorite = () => {
      store.commit(MUTATIONS_KEYS.SET_FAVORITE, props.video)
    }

    return {
      id,
      isFavorite,
      onFavorite
    }
  }
})
